import { render } from "./ReporteGestion.vue?vue&type=template&id=277632e8&scoped=true"
import script from "./ReporteGestion.vue?vue&type=script&lang=js"
export * from "./ReporteGestion.vue?vue&type=script&lang=js"

import "./ReporteGestion.vue?vue&type=style&index=0&id=277632e8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-277632e8"]])

export default __exports__